import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

interface VariantImageProps {
    image: string;
    size: 'big' | 'small';
    contain?: boolean | null | undefined;
    style?: CSSProperties;
    className?: string;
}

export const VariantImage = (props: VariantImageProps) => {
    return (
        <S_VariantImage className={props.className} style={props.style} $size={props.size}>
            {props.image && (
                <S_Image
                    src={props.image}
                    alt="variant"
                    width={props.size === 'big' ? 91 : 46}
                    height={props.size === 'big' ? 66 : 46}
                    style={{ objectFit: props.contain ? 'contain' : 'cover' }}
                />
            )}
        </S_VariantImage>
    );
};

const S_VariantImage = styled.div<{ $size: 'big' | 'small' }>`
    width: ${({ $size }) => ($size === 'big' ? '95px' : '50px')};
    height: ${({ $size }) => ($size === 'big' ? '70px' : '50px')};
    border-radius: 7px;
    border: 2px solid ${({ theme }) => theme.colors.white};
    box-shadow: ${variantShadow};
    background: ${({ theme }) => theme.colors.white};
`;

const S_Image = styled.img`
    border-radius: 7px;
`;
